import React, { useState, useContext, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import _find from 'lodash/find'
import _isEqual from 'lodash/isEqual'
import { customMedia } from '../../common/customMedia'
import { MyCarousel } from '../../common/MyCarousel'
import { Image } from '../../common/Image'
import { Acumin } from '../../common/Acumin'
import { SpOnly } from '../../common/SpOnly'
import { PcOnly } from '../../common/PcOnly'

import { StoreContext } from '../../../context/StoreContext'

export interface Props {
  product: any
}

export const BrooklynMachineWorksGangstaUcchieEdition = (props: Props) => {
  const { product } = props

  const [width, setWidth] = useState(0)

  const SOLDOUT = true

  useEffect(() => {
    const handleResize = () => {
      setWidth(0)
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    handleResize()
  }, [])

  const {
    options,
    variants,
    variants: [initialVariant]
  } = product
  const [variant, setVariant] = useState({ ...initialVariant })
  const [quantity, setQuantity] = useState(1)
  const {
    addVariantToCart,
    removeLineItem,
    store: { client, adding, checkout },
  } = useContext(StoreContext)

  // const productVariant = client.product.helpers.variantForOptions(product, variant) || variant
  const productVariant = variant
  const [available, setAvailable] = useState(productVariant.availableForSale)
  const [keyword, setKeyword] = useState('')

  const checkAvailability = useCallback(
    productId => {
      client.product.fetch(productId).then(fetchedProduct => {
        // this checks the currently selected variant for availability
        const result = fetchedProduct.variants.filter(
          variant => variant.id === productVariant.shopifyId
        )
        if (result.length > 0) {
          setAvailable(result[0].available)
        }
      })
    },
    [client.product, productVariant.shopifyId, variants]
  )

  useEffect(() => {
    checkAvailability(product.shopifyId)
  }, [productVariant, checkAvailability, product.shopifyId])

  const handleQuantityChange = ({ target }) => {
    setQuantity(target.value)
  }

  const handleOptionChange = (optionIndex, { target }) => {
    const { value } = target
    const currentOptions = [...variant.selectedOptions]

    currentOptions[optionIndex] = {
      ...currentOptions[optionIndex],
      value,
    }

    const selectedVariant = _find(variants, ({ selectedOptions }) =>
      _isEqual(currentOptions, selectedOptions)
    )

    setVariant({ ...selectedVariant })
  }

  const handleKeywordChange = (e: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    setKeyword(e.target.value as string)
  }

  const handleAddToCart = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    // お一人様一点限りのためカート追加の前に空にする
    await Promise.all(
      checkout.lineItems.map(async lineItem => {
        await removeLineItem(client, checkout.id, lineItem.id)
      })
    )
    await addVariantToCart(productVariant.shopifyId, 1).then(() => {
      // @ts-ignore
      location.href = checkout.webUrl
    })
  }

  const checkDisabled = (name, value) => {
    const match = _find(variants, {
      selectedOptions: [
        {
          name: name,
          value: value,
        },
      ],
    })
    if (match === undefined) return true
    if (match.availableForSale === true) return false
    return true
  }

  return (
    <>
      <Container>
        <ProductContainer>
          <ProductDetails>
            <SpOnly>
              <Title>BROOKLYN MACHINE<br />WORKS GANGSTA<br />“UCCHIE” edition</Title>
            </SpOnly>
            <PcOnly>
              <Title>BROOKLYN<br />MACHINE<br />WORKS GANGSTA<br />“UCCHIE” edition</Title>
            </PcOnly>
            <Row>
              <div>Price</div>
              <div>{Math.round(product.priceRange.maxVariantPrice.amount).toLocaleString()}<span style={{ fontSize: '12px' }}>（税込・送料込）</span></div>
              <div>数量</div>
              <div>
                <Acumin>
                  <select
                    name='quantity'
                    onChange={event => handleQuantityChange(event)}
                  >
                    <option value={1}>1</option>
                  </select>
                </Acumin>
              </div>
            </Row>
            <Table>
              <tbody>
                <Tr>
                  <Td width={80}>Price</Td>
                  <Td>{Math.round(product.priceRange.maxVariantPrice.amount).toLocaleString()}yen<span style={{ fontSize: '16px' }}>（税込・送料込）</span></Td>
                </Tr>
                <Tr>
                  <Td width={80}>数量</Td>
                  <Td>
                    <Acumin>
                      <select
                        name='quantity'
                        onChange={event => handleQuantityChange(event)}
                      >
                        <option value={1}>1</option>
                      </select>
                    </Acumin>
                  </Td>
                </Tr>
              </tbody>
            </Table>

            <SpOnly>
              <CarouselWrapper>
                <MyCarousel>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem1.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem2.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem3.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem4.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem5.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem6.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem7.jpg' />
                  </ImageWrapper>
                  <ImageWrapper width={width}>
                    <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem8.jpg' />
                  </ImageWrapper>
                </MyCarousel>
              </CarouselWrapper>
            </SpOnly>

            <InfoContainer>
              <Info>
                ＊完成車での販売となります。<br />
                ＊フレームバッグ及びTea Bucksボトル・ゆず緑茶が付属します。<br />
                ＊配送のみとなります。<br />
                ＊ご注文はお一人様一点限りとさせていただきます。
              </Info>
              <Info>
                ＜販売内容＞<br />
                BROOKLYN MACHINE WORKS GANGSTA UCCHIE edition <br />
                RAW<br />
                <br />
                フレームサイズ：M(54)<br />
                トップチューブ：545mm<br />
                TT(ホリゾンタル)：566mm<br />
                チェーンステー：400mm<br />
                ヘッド角：74.5°<br />
                シート角：73°<br />
                BB：60mm<br />
                シートチューブ(C-T)：540mm<br />
                ヘッドチューブ：133mm<br />
                シートポスト径：27.2mm<br />
                <br />
                SPEC<br />
                フレーム：CR-M<br />
                フォーク：CR-M<br />
                ヘッドセット：BROOKLYN MACHINE WORKS INTEGRAL HEADSET<br />
                バーエンド：BROOKLYN MACHINE WORKS AL6061<br />
                ステム：FLATRAT STEM AL6061 φ31.8/55mm<br />
                ヘッドパーツ：1 1/2”SEALED BEARING<br />
                フロント/リアブレーキ：TEKTRO RX6[MINI-V] ＊前後リムーバブル台座(MINI Vブレーキ適合)<br />
                クランク/チェーンリング：BROOKLYN MACHINE WORKS 170mm BCD130mm w/46T<br />
                BB：FSA CARTRIDGE<br />
                チェーン：KMC Z510HX<br />
                フリーウィール：1/2" x 1/8" x 17T<br />
                コグ：STEEL 1/2" x 1/8" x 17T（＊リア両切ハブ）<br />
                フロント/リアリム：HJC DA-24 32H 700C<br />
                フロント/リアハブ：NOVATEC A165SBT 32H/14G<br />
                スポーク：STAINLESS #14<br />
                リムテープ：NYLON / FV<br />
                シートクランプ：ALLOY 29.8mm<br />
                <br />
                ハンドルバー：ADEPT Spread Riser Bar<br />
                グリップ：ANIMAL BIKES<br />
                ブレーキレバー：ODYSSY MONOLEVER<br />
                シートポスト：THOMSON Elite<br />
                シート：ODYSSY Mike Aitken<br />
                ペダル：CINEMA CK PEDAL<br />
                タイヤ：MAXXIS OVERDRIVE 700x38c<br />
                ＊完成車のコンポーネントは予告なしに変更となる可能性がございます。<br />
                その場合、同等グレードの代替品を組み付け致します。予めご了承ください。<br />
                <br />
                フレームバッグ：AGHARTA<br />
                ボトル&ティーバッグ：Tea Bucksボトル&ゆず緑茶<br />
                <br />
                ボトル仕様<br />
                原　材　料：飽和ポリエステル樹脂 (ボトル本体) /ポリプロピレン (フタ、スプラッシュガード) <br />
                容　　　量：500ml<br />
                サ　イ　ズ：約 W65mm × D65mm × H195mm<br />
                耐 熱 温 度：90℃ (ボトル本体) / 110℃ (フタ) / 160℃ (スプラッシュガード)<br />
                耐 冷 温 度：-40℃ (ボトル本体、フタ、スプラッシュガード)<br />
                生　産　国：中国<br />
                ＊電子レンジ/食洗機はお使いいただけません。<br />
                <br />
                ゆず緑茶<br />
                産地：熊本県益城町<br />
                製造元：株式会社　お茶の富澤

              </Info>
              {/* <Info>素材： コットン100%</Info> */}
            </InfoContainer>
          </ProductDetails>

          <CarouselWrapper>
            <PcOnly>
              <MyCarousel>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem1.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem2.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem3.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem4.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem5.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem6.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem7.jpg' />
                </ImageWrapper>
                <ImageWrapper>
                  <Image path='brooklyn-machine-works-gangsta-ucchie-edition/buyitem8.jpg' />
                </ImageWrapper>
              </MyCarousel>
            </PcOnly>
          </CarouselWrapper>
        </ProductContainer>

        <BtoNoticeContainer>
          <div>完全受注制作</div>
          <div>
            BROOKLYN MACHINE WORKS GANGSTAフレームは極少量の入荷のため、販売台数は4台限定となります。<br />
            受注期間：2020年8月31日（月）〜9月14日（月）まで<br />
            発送時期：2020年10月中旬頃より順次発送予定<br />
            ＊受注受付期間内であっても、販売予定数量に達し次第、オーダー受付を終了させて頂きます。<br />
            ＊お客様のご都合による返品・交換はお受けしかねます。予めご了承ください。<br />
          </div>

          <div>
            ＜注意書き＞<br />
            ・2017年7月より運送会社の荷物規定改定のため従来の完成車の状態での発送が出来なくなっております。ハンドルバー、ペダル、フロントホイールを取り外した状態での発送となりますので車体がお手元に到着しましたらお客様ご自身、またはお近くの自転車店にてハンドルバー、ペダル、フロントホイールの取り付けを行って頂くことになります。ご購入の際は予めご了承ください。<br />
            ・防犯登録は法律により義務化されています。お買い上げの自転車は防犯登録を行ってからご使用ください。<br />
            ・道路交通法施行規則で、前車輪及び後車輪を制動することなどが規定されています。公道での走行には、必ず前後ブレーキの完動装置を備えてください。<br />
            ・自転車は点検整備が必要です。日常的に安全点検を行ってください。また、購入後1ヶ月、半年から1年毎に定期点検をお受けください。<br />
            ・点検や整備、防犯登録（解除）の費用はお客様のご負担となります。<br />
            ・お近くに取扱店がなくインターネットショッピングでお買い求め頂く場合でも、必ず自転車整備有資格者のいる店舗で点検をお受けください。<br />
            ・お客様、またはお客様がご依頼された自転車店の組み付けによる事故について、弊社及びW-BASEは一切の責任を負いかねます。
          </div>
        </BtoNoticeContainer>

        <form onSubmit={handleAddToCart}>
          <ButtonWrapper>
            <AddToCartButton type="submit" disabled={!available || adding || SOLDOUT}>
              <Acumin>SOLD OUT</Acumin>
              <Shadow />
            </AddToCartButton>
          </ButtonWrapper>
        </form>

      </Container>
    </>
  )
}

const Container = styled.div`
  ${customMedia.lessThan("medium")`
    padding: 0 20px;
  `}
  ${customMedia.greaterThan("medium")`
    margin: 40px auto 0;
    width: 1000px;
  `}
`

const ProductContainer = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  `}
`

const ProductDetails = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 50px;
  `}

  position: relative;
`

const Title = styled.div`
  font-family: 'EB Garamond', serif;
  font-size: 4rem;
  
  ${customMedia.lessThan("medium")`
    font-size: 3rem;
  `}
  ${customMedia.greaterThan("medium")`
    span {
      font-size: 8rem;
    }
  `}
`

const Row = styled.div`
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  width: 80%;

  * {
    font-family: 'EB Garamond', serif;
    font-size: 1.4rem;

    :nth-child(3) {
      font-size: 1rem;
    }
  }
  
  ${customMedia.greaterThan("medium")`
    display: none;
  `}
`

const Table = styled.table`
  ${customMedia.lessThan("medium")`
    display: none;
  `}

  * {
    font-size: 2.5rem;
  }

  table-layout: fixed;
`

const Tr = styled.tr`
  font-family: 'EB Garamond', serif;
  
  ${customMedia.greaterThan("medium")`
    height: 40px;

    :nth-of-type(2) {
      td {
        font-size: 2rem;
      }
    }
  `}

  :nth-of-type(2) {
    font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
    font-weight: 600;
    font-style: normal;
  }
`

const Td = styled.td`
  ${customMedia.lessThan("medium")`
    display: none;
  `}
`

const InfoContainer = styled.div`
  ${customMedia.lessThan("medium")`
    margin-top: 10px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.8rem;
    margin-top: 60px;
  `}

  font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
  font-weight: 600;
  font-style: normal;
  letter-spacing: -1px;
`

const Info = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1rem;
    margin-top: 10px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.4rem;
    margin-top: 20px;
  `}
`

const SizeContainer = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1rem;
    width: 190px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    margin-top: 60px;
    width: 380px;
  `}

  font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
  font-weight: 600;
  font-style: normal;
`

const Size = styled.div`
  ${customMedia.lessThan("medium")`
    height: 25px;
    line-height: 25px;

    span {
      font-size: 1.2rem;
      width: 20px;

      :first-child {
        text-align: center;
        margin-right: 10px;
      }
    }
  `}
  ${customMedia.greaterThan("medium")`
    height: 40px;
    line-height: 40px;

    span {
      font-size: 2.4rem;
      margin-right: 20px;
      width: 34px;

      :first-child {
        text-align: center;
        margin-right: 18px;
      }

      :last-child {
        margin-right: 0;
      }
    }
  `}

  border-bottom: 1px #000 solid;

  :nth-child(3) {
    border: none;
  }
  
  span {
    display: inline-block;
  }

  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: center;
  flex-wrap: center;
  -webkit-align-items: center;
  align-items: center;
`

const CarouselWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin: 10px 0 0;

    ul.control-dots {
      position: relative;
    }
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 60px;
    width: 48%;

    ul.control-dots {
      position: relative;
      text-align: center;
    }
  `}

  li {
    :focus {
      outline: 0;
    }
  }

  li.slide, li.slide.selected {
    background-color: #fff;
  }
`

const ImageWrapper = styled.div<{ width?: number }>`
  ${props => customMedia.lessThan("medium")`
    margin: 0 auto;
    height: ${props.width - 40}px;
    width: ${props.width - 40}px;

    img {
      height: ${props.width - 40}px !important;
      width: ${props.width - 40}px !important;
    }
  `}
  ${customMedia.greaterThan("medium")`
    width: 400px;
    margin: 0 auto;
  `}
`

const BtoNoticeContainer = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1rem;
    margin-top: 20px;

    div {
      :nth-child(1) {
        padding: 2px 5px 2.5px;
        margin-bottom: 5px;
        width: 80px;
      }
      :nth-child(2) {
        font-size: 0.8rem;
      }
      :nth-child(3) {
        font-size: 0.6rem;
      }
    }
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    margin-top: 50px;

    div {
      :nth-child(1) {
        padding: 4.5px 10px 6px;
        margin-bottom: 10px;
        width: 120px;
      }
      :nth-child(3) {
        font-size: 1.2rem;
        margin-top: 20px;
      }
    }
  `}

  div {
    :nth-child(1) {
      background-color: #000;
      color: #fff;
      text-align: center;
    }
  }

  font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
  font-weight: 600;
  font-style: normal;
  letter-spacing: -0.5px;
`

const KeywordFormContainer = styled.div`
  ${customMedia.lessThan("medium")`
    margin-top: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 40px;
  `}

  text-align: center;
  position: relative;
`

const KeywordDescription = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 0.8em;
    margin-top: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.4rem;
    margin-top: 40px;
  `}

  font-family: a-otf-midashi-go-mb31-pr6n, sans-serif;
  font-weight: 600;
  font-style: normal;
  letter-spacing: -0.5px;
  text-align: center;
`

const VideoWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    margin-top: 10px;

    video {
      width: 100%;
    }
  `}
  ${customMedia.greaterThan("medium")`
    margin-top: 20px;

    video {
      width: 600px;
    }
  `}
`

// const DummyVideo = styled.div`
//   ${customMedia.lessThan("medium")`
//     margin: 10px 0;
//     width: 100%;
//   `}
//   ${customMedia.greaterThan("medium")`
//     border: 1px #000 solid;
//     margin: 20px auto;
//     height: 337.5px;
//     width: 600px;
//   `}
// `

const KeywordInput = styled.input`
  ${customMedia.lessThan("medium")`
    font-size: 0.8rem;
    height: 20px;
    margin-top: 10px;
    padding: 2.5px 5px 0;
    width: 150px;

    ::placeholder {
      font-size: 0.8rem;
    }
    
    :-ms-input-placeholder {
      font-size: 0.8rem;
    }
    
    ::-ms-input-placeholder {
      font-size: 0.8rem;
    }
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.4rem;
    height: 40px;
    margin-top: 40px;
    padding: 5px 10px 0;
    width: 200px;

    ::placeholder {
      font-size: 1.4rem;
    }
    
    :-ms-input-placeholder {
      font-size: 1.4rem;
    }
    
    ::-ms-input-placeholder {
      font-size: 1.4rem;
    }
  `}

  background-color: #cdcdcd;
  border: none;
  font-weight: bold;

  ::placeholder {
    color: #fff;
    opacity: 1;
    text-align: center;
  }
  
  :-ms-input-placeholder {
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
  
  ::-ms-input-placeholder {
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
`

const ButtonWrapper = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
  `}

  text-align: center;
`

const AddToCartButton = styled.button`
  ${customMedia.lessThan("medium")`
    border: 2px #000 solid;
    height: 26px;
    margin-top: 20px;
    width: 88px;

    span {
      font-size: 1.75rem;
    }
  `}
  ${customMedia.greaterThan("medium")`  
    border: 4px #000 solid;
    height: 45px;
    margin-top: 40px;
    width: 140px;

    span {
      font-size: 3.5rem;
    }
  `}
  
  background-color: #fff;
  cursor: pointer;
  color: #000;
  font-family: 'AcuminVariableConcept';
  font-variation-settings: 'wght' 550, 'wdth' 55;
  font-weight: bold;
  position: relative;
  text-align: center;

  :focus {
    outline: 0;
  }
`

const Shadow = styled.div`
  ${customMedia.lessThan("medium")`
    height: 26px;
    top: 2px;
    left: 2px;
    width: 88px;
  `}
  ${customMedia.greaterThan("medium")`
    height: 45px;
    top: 4px;
    left: 4px;
    width: 140px;
  `}

  background-color: #000;
  position: absolute;
  z-index: -1;
`
